export default __webpack_public_path__ + "88adf693d1ebb3ac4bf5d6d9108cb6c6.png";